import { supabase } from "@/integrations/supabase/client";

export type UploadedFile = {
  path: string;
  url: string;
  name: string;
  size: number;
  kind: "pdf" | "image" | "video" | "document" | "file";
};

function kindOf(file: File): UploadedFile["kind"] {
  const t = file.type;
  if (t.startsWith("image/")) return "image";
  if (t.startsWith("video/")) return "video";
  if (t === "application/pdf") return "pdf";
  if (/wordprocessingml|msword|presentationml|spreadsheetml|opendocument/.test(t)) return "document";
  return "file";
}

export async function uploadToBucket(bucket: string, file: File, folder = ""): Promise<UploadedFile> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error("Not signed in");
  const safe = file.name.replace(/[^a-zA-Z0-9._-]+/g, "_");
  const path = [user.id, folder, `${Date.now()}_${safe}`].filter(Boolean).join("/");
  const { error } = await supabase.storage.from(bucket).upload(path, file, { upsert: false, contentType: file.type || undefined });
  if (error) throw error;
  const { data: signed } = await supabase.storage.from(bucket).createSignedUrl(path, 60 * 60 * 24 * 365);
  return { path, url: signed?.signedUrl ?? "", name: file.name, size: file.size, kind: kindOf(file) };
}

export async function signedUrl(bucket: string, path: string, seconds = 3600): Promise<string> {
  const { data } = await supabase.storage.from(bucket).createSignedUrl(path, seconds);
  return data?.signedUrl ?? "";
}
